import { colors } from '../constants/colors';
import { DEAL_STATUS_FAILED, DEAL_STATUS_REJECTED } from '../constants';
import { DEAL_STATUS_TTL_EXPIRED } from '../constants/dealStatuses';

const FAILED_DEAL_STATUSES = [DEAL_STATUS_FAILED, DEAL_STATUS_REJECTED, DEAL_STATUS_TTL_EXPIRED];

/**
 * Цвет бейджа сделки в списке лидов (колонка «Сделка»).
 *
 * Зелёный — по факту одобрения (dealStatus.bankApproved, бэкенд берёт его из заявок),
 * а не по статусу «Есть одобрение банка»: статус у сделки один и уходит дальше
 * (договор, залог, выдача), а менеджеру нужно видеть именно одобрили или нет.
 */
const leadDealStatusColor = (dealStatus) => {
  if (FAILED_DEAL_STATUSES.includes(dealStatus?.id)) return colors.red;
  return dealStatus?.bankApproved ? colors.green : colors.dimGray;
};

export default leadDealStatusColor;
